import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const partyPhotoUrl = 'https://cdn.magicpatterns.com/uploads/uemY9CkKimryYgGwtLWmr1/o9MBDefGZtGV0uFifunKoGke88OS75JDKHQTOG0yGTEw6_8KsmrCvSGB302D4Kg_yS1vXooDF0rx3pQJOD_u1qwNRcDdsRjFlt7yvfBioq8.jpg';
  const mockupUrl = 'https://cdn.magicpatterns.com/uploads/2bhUqhVfWCjsiC5Nb3JXQb/Party-Favor-Templates-Mockup-Bundle-5x7-CANVA_use_1200x.webp';
  return <section className="relative min-h-screen w-full bg-gradient-to-b from-pink-50 via-white to-white overflow-hidden pt-16 pb-20" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-97">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left z-10" data-id="element-98">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-99">
              <span className="inline-block px-6 py-2 bg-rose-100 text-rose-600 rounded-full text-sm font-bold mb-6 shadow-sm" data-id="element-100">
                🎉 Mega Kit Imprimible — 26 Carpetas · +25.000 Archivos
              </span>
            </motion.div>

            <motion.h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-tight mb-6" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.1
          }} data-id="element-101">
              Organiza cumpleaños increíbles{' '}
              <span className="bg-gradient-to-r from-rose-500 to-pink-500 bg-clip-text text-transparent" data-id="element-102">
                o empieza un negocio digital
              </span>{' '}
              desde casa
            </motion.h1>

            <motion.p className="text-lg sm:text-xl text-slate-600 mb-4 max-w-2xl mx-auto lg:mx-0" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-103">
              Más de 25.000 decoraciones imprimibles listas para usar. Descargá,
              imprimí y sorprendé.
            </motion.p>

            {/* Volume indicator */}
            <motion.div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.25
          }} data-id="element-104">
              <span className="px-4 py-2 bg-gradient-to-r from-rose-500 to-pink-500 text-white font-bold rounded-full text-sm shadow-md" data-id="element-105">
                📂 26 carpetas
              </span>
              <span className="px-4 py-2 bg-gradient-to-r from-amber-400 to-amber-500 text-white font-bold rounded-full text-sm shadow-md" data-id="element-106">
                📄 +1000 archivos cada una
              </span>
              <span className="px-4 py-2 bg-gradient-to-r from-green-400 to-green-500 text-white font-bold rounded-full text-sm shadow-md" data-id="element-107">
                ✏️ Editables en Canva
              </span>
            </motion.div>

            {/* Use Case Pills */}
            <motion.div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-108">
              <div className="px-5 py-3 bg-white border-2 border-rose-200 rounded-xl shadow-sm text-slate-700 font-semibold flex items-center gap-2" data-id="element-109">
                <span data-id="element-110">🎉</span> Decorar cumpleaños increíbles
              </div>
              <div className="px-5 py-3 bg-white border-2 border-amber-200 rounded-xl shadow-sm text-slate-700 font-semibold flex items-center gap-2" data-id="element-111">
                <span data-id="element-112">💰</span> Vender kits digitales y generar ingresos
              </div>
            </motion.div>

            {/* Benefits Row */}
            <motion.div className="flex flex-wrap justify-center lg:justify-start gap-4 text-sm font-medium text-slate-600 mb-10" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-113">
              <span className="flex items-center gap-1 bg-pink-50 px-3 py-1 rounded-full" data-id="element-114">
                🖨️ Imprime en casa
              </span>
              <span className="flex items-center gap-1 bg-pink-50 px-3 py-1 rounded-full" data-id="element-115">
                💻 Producto digital
              </span>
              <span className="flex items-center gap-1 bg-pink-50 px-3 py-1 rounded-full" data-id="element-116">
                ⚡ Descarga inmediata
              </span>
            </motion.div>

            {/* CTA Area */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="flex flex-col items-center lg:items-start" data-id="element-117">
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-10 py-5 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-xl font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-118">
                👉 Acceder al Mega Kit — $27.990 ARS
              </a>
              <p className="mt-3 text-sm text-slate-500 font-medium" data-id="element-119">
                ⚡ Acceso inmediato después de la compra ·{' '}
                <span className="text-rose-500 font-bold" data-id="element-120">
                  Precio de lanzamiento
                </span>
              </p>
            </motion.div>
          </div>

          {/* Images Area */}
          <div className="flex-1 relative w-full max-w-lg lg:max-w-none mx-auto mt-10 lg:mt-0" data-id="element-121">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative z-0" data-id="element-122">
              <img src={partyPhotoUrl} alt="" className="w-full h-auto rounded-3xl shadow-2xl object-cover border-4 border-white rotate-2" data-id="element-123" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 50
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="absolute -bottom-10 -left-6 sm:-left-12 w-2/3 z-10 animate-float" data-id="element-124">
              <img src={mockupUrl} alt="" className="w-full h-auto rounded-2xl shadow-2xl object-cover border-4 border-white -rotate-3" data-id="element-125" />
            </motion.div>
          </div>
        </div>

        {/* Bottom Tagline */}
        <motion.div className="mt-24 text-center bg-white/80 backdrop-blur-sm py-6 px-4 rounded-2xl border border-rose-100 shadow-sm max-w-4xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} data-id="element-126">
          <p className="text-lg sm:text-xl font-bold text-slate-800" data-id="element-127">
            💬 "Ideal para mamás que quieren organizar cumpleaños increíbles o
            empezar un pequeño negocio digital."
          </p>
        </motion.div>
      </div>
    </section>;
}